export const validateEmail = email => {
  const isValidEmail = !!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3,4})+$/.test(
    email
  );
  return isValidEmail;
};

export const validateDNI = dni => {
  const regExpDni = /^[0-9]{8,8}[A-Za-z]$/;
  return regExpDni.test(dni);
};
